import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import SummarySellerTiles from './SellerTiles';
import { StoreBasicDataApiStructure } from 'common/types';
import { repositories } from 'api';
import { getIsUserPromoter } from 'store/ducks/me/selectors';

type Props = {
    isPromoter: boolean,
    notes: string | undefined | null,
};

const SummaryNotesPanel: React.FC<Props> = ({ isPromoter, notes, }) => {
    if (!isPromoter || !notes) {
        return null;
    }

    return (
        <SummarySellerTiles renderHeader="Uwagi">
            <Grid container
                  direction="column">
                <Typography variant="subtitle1">
                    {notes}
                </Typography>
            </Grid>
        </SummarySellerTiles>
    );
};

type MappingType = {
    me: StoreBasicDataApiStructure<repositories.MeType>,
    checkout: {
        values: any,
    }
};

const mapStateToProps = (state: MappingType) => ({
    isPromoter: getIsUserPromoter(state),
    notes: state.checkout.values?.notes,
});

export default connect(
    mapStateToProps,
)(SummaryNotesPanel);
